import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import customersService from 'services/admin/customersService';

export default function CustomersAutocompleteField({ label, setValue }) {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let active = true;

        // Debounce API requests
        const timer = setTimeout(async () => {
            setLoading(true);
            try {
                const res = await customersService.getAll({ query: inputValue, limit: 100 });
                if (active) {
                    let customers = res.data.rows
                    if (customers) {
                        customers = customers.filter(c => c.id !== null)
                    }
                    setOptions(customers);
                }
            } catch (err) {
                console.error(err);
            } finally {
                if (active) setLoading(false);
            }
        }, 400);

        return () => {
            active = false;
            clearTimeout(timer);
        };
    }, [inputValue]);

    return (
        <Autocomplete
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            getOptionLabel={(option) => (option.lastName || '') + ' ' + (option.firstName || '')}
            options={options}
            loading={loading}
            onInputChange={(event, value) => setInputValue(value)}
            onChange={(event, value) => setValue(value)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
}
